import { ENUM__ml_asset_type } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_type';
import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { ENUM__field_role } from '../../_invocations/_base/ENUM__field_role';
import { DECORATOR__ui_without_component } from '../_base/_decorators/DECORATOR__ui_without_component';
import { ENUM__field_graph_interaction } from '../_base/_enums/ENUM__field_graph_interaction';
import { ENUM__field_store_interaction } from '../_base/_enums/ENUM__field_store_interaction';
import { ENUM__field_connectable_type } from '../_base/_methods/ENUM__field_connectable_type';
import { FIELD__base_visible_connectable } from '../_base/FIELD__base_connectable';
import { DECORATOR__class_serialization_tested } from '../_primitives/_base/DECORATOR__class_serialization_tested';
import { DECORATOR__class_serialization_tested_for_hash } from '../_primitives/_base/DECORATOR__class_serialization_tested_for_hash';
import { DECORATOR__field_not_linked } from '../_primitives/_base/DECORATOR__field_not_linked';
import { FIELD__list_lora } from '../_primitives/list/FIELD__list_lora';
import { FIELD_PRIMITIVE__string_hash_ml_asset } from '../_primitives/string/hash/FIELD_PRIMITIVE__string_hash_ml_asset';
import { FIELD__ml_asset_unet_free_u } from './FIELD__ml_asset_unet_free_u';

@DECORATOR__class_serialization_tested
@DECORATOR__class_serialization_tested_for_hash
export class FIELD__ml_asset_unet extends FIELD__base_visible_connectable {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_ML_ASSET_UNET;

  /*
   * FIELDS
   */

  @FIELD_PRIMITIVE__string_hash_ml_asset.init_field_with_type(ENUM__ml_asset_type.UNET, {
    field_role: ENUM__field_role.MODEL__UNET,
    store__interaction: ENUM__field_store_interaction.READ_AND_WRITE,
  })
  //todo:rename to hash_sha256
  model!: FIELD_PRIMITIVE__string_hash_ml_asset;

  @FIELD_PRIMITIVE__string_hash_ml_asset.init_field_with_type(ENUM__ml_asset_type.SCHEDULER_CONFIG, { field_role: '📈 Scheduler Config' })
  scheduler_config!: FIELD_PRIMITIVE__string_hash_ml_asset;

  @FIELD__list_lora.init_as_field({
    item_meta: MAP__serializable.from_object({ graph__interaction: ENUM__field_graph_interaction.HIDDEN }),
  })
  loras!: FIELD__list_lora;

  //todo: use enum: only x, only y, x and y, none
  seamless_axes!: string[];

  @FIELD__ml_asset_unet_free_u.init_as_input()
  freeu_config!: FIELD__ml_asset_unet_free_u;

  /*
   * PROPERTIES
   */
  field_connectable__type() {
    return ENUM__field_connectable_type.ML_ASSET__UNET;
  }

  field_connectable__value(graph: DTO_GRAPH__instance): string {
    return this.model.find_source(graph).field_connectable__value(graph);
  }

  /*
   * METHODS
   */

  constructor() {
    super();
  }

  @DECORATOR__ui_without_component
  post_init(): void {
    super.post_init();
  }

  @DECORATOR__field_not_linked()
  store__serialization_keys_list_white_for_hash(): string[] {
    let out: (keyof this)[] = [];

    out.push('model');
    out.push('loras');
    out.push('freeu_config');
    out.push('scheduler_config');

    return out as string[];
  }
}
